import { getDojoActivityStatus } from './dojoActivityStatus';

const ALL_TYPES = ['workout', 'meal', 'media', 'metric', 'survey'];
const ALL_STATUSES = ['complete', 'pending', 'ongoing', 'expired'];

const selectedOrAll = (map, all) => {
  const selected = all.filter((key) => !!map?.[key]);
  return selected.length === 0 || selected.length === all.length ? null : new Set(selected);
};

export const isActivityTypeVisibleInFeed = (filters, type) => {
  const selectedTypes = selectedOrAll(filters?.types, ALL_TYPES);
  return !selectedTypes || selectedTypes.has(type);
};

const matchesStatus = (activity, selectedStatuses, now) => {
  if (!selectedStatuses) return true;
  const normalized = getDojoActivityStatus(activity, new Date(now)).status;
  const dueAt = activity.due_at ? new Date(activity.due_at).getTime() : null;
  const fallbackStatus = dueAt === null ? 'pending' : dueAt >= now ? 'ongoing' : 'expired';
  const filterStatus = normalized === 'done'
    ? 'complete'
    : normalized === 'live'
      ? 'ongoing'
      : normalized === 'missed'
        ? 'expired'
        : fallbackStatus;
  return selectedStatuses.has(filterStatus);
};

export const filterActivitiesForFeed = (activities, filters, now = Date.now()) => {
  const selectedTypes = selectedOrAll(filters?.types, ALL_TYPES);
  const selectedStatuses = selectedOrAll(filters?.statuses, ALL_STATUSES);
  return (Array.isArray(activities) ? activities : []).filter((activity) => {
    if (selectedTypes && !selectedTypes.has(activity.type)) return false;
    return matchesStatus(activity, selectedStatuses, now);
  });
};

export const parentTravelReplacementActivities = activities => (
  (Array.isArray(activities) ? activities : []).filter(activity => !(
    activity?.type === 'workout'
    && activity?.source?.compliance_role !== 'travel_replacement'
    && Boolean(activity?.travel_replacement_id)
  ))
);

export { ALL_TYPES, ALL_STATUSES };
// Pure helper intentionally has no React/backend dependencies so filter behavior
// can be regression-tested independently from feed rendering and pagination.
